import React, { useState } from "react";
import ProfileSettings from "../../components/admin/settings/ProfileSettings";
import NotificationSettings from "../../components/admin/settings/NotificationSettings";
import SecuritySettings from "../../components/admin/settings/SecuritySettings";
import ThemeSettings from "../../components/admin/settings/ThemeSettings";

export default function SettingsPage() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <div className="p-8 bg-white dark:bg-gray-800 rounded-lg shadow md:ml-64 max-w-5xl mx-auto space-y-12">
      <h2 className="text-3xl font-bold text-gray-900 dark:text-white text-center mb-8">
        Settings
      </h2>

      <ProfileSettings />
      <NotificationSettings />
      <SecuritySettings />
      <ThemeSettings darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </div>
  );
}
